import { FC, HTMLProps, ReactNode } from "react";
import styles from "./Label.module.css";

interface Props extends HTMLProps<HTMLDivElement> {
  children: ReactNode;
}

export const Label: FC<Props> = ({ children, className = "", ...rest }) => {
  return (
    <div {...rest} className={`${styles.container} ${className}`}>
      {children}
    </div>
  );
};
